import { PropsWithChildren, useEffect } from "react";
import { useSelector } from "react-redux";
import DataLoadingFailed from "../../../../../shared/components/DataLoadingFailed";
import InlineLoader from "../../../../../shared/components/inlineLoader/InlineLoader";
import useMetaDataInitialization from "../../../../hooks/useMetaDataInitialization";
import { useAppDispatch } from "../../../../store/hooks/useAppDispatch";
import { selectMetaDataLoaded, selectMetaDataLoadingFailed } from "../../../../store/selectors/metaDataSelectors";
import {
  selectDrillDownConfiguration,
  selectDrillDownConfigurationLoading,
  selectDrillDownConfigurationLoadingFailed,
} from "../../../../store/slices/drillDownConfigurationSlice";
import { loadDrillDownConfiguration } from "../../../../store/thunks/drillDownConfigurationThunks";

const DrillDownConfigurationLoader = ({ children }: PropsWithChildren) => {
  const dispatch = useAppDispatch();
  const drillDownConfiguration = useSelector(selectDrillDownConfiguration);
  const isLoadingConfiguration = useSelector(selectDrillDownConfigurationLoading);
  const configurationLoadingFailed = useSelector(selectDrillDownConfigurationLoadingFailed);
  const metaDataLoaded = useSelector(selectMetaDataLoaded);
  const metaDataLoadingFailed = useSelector(selectMetaDataLoadingFailed);

  const shouldLoadMetaData = !metaDataLoaded;
  useMetaDataInitialization(shouldLoadMetaData);

  useEffect(() => {
    if (!drillDownConfiguration) {
      dispatch(loadDrillDownConfiguration());
    }
  }, [dispatch, drillDownConfiguration]);

  if (isLoadingConfiguration || !metaDataLoaded) {
    return <InlineLoader text="Loading drill down configuration..." overlay={true} />;
  }

  if (configurationLoadingFailed || metaDataLoadingFailed) {
    return <DataLoadingFailed text="Error loading drill down configuration" />;
  }

  return <>{children}</>;
};

export default DrillDownConfigurationLoader;
